// @flow
function getQueryParameter(search: string, name: string): string|null {
    const expression = `${name}=(\\w+)[&]*`
    const result = new RegExp(expression).exec(search)
    return result !== null ? result[1] : null
}
export default getQueryParameter